export const ROLE_GUEST = 'guest';